import { render } from "./AdvanceDirectives.vue?vue&type=template&id=7adc96de&ts=true"
import script from "./AdvanceDirectives.vue?vue&type=script&lang=ts"
export * from "./AdvanceDirectives.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__